// src/permissions.js

export const PERMISSIONS = {
  admin: {
    createBuild: true,
    viewBuilds: true,
    modifyBuilds: true,
    executeBuilds: true,
    viewData: true,
    uploadData: true,
    deleteData: true,
    downloadData: true,
    viewAnalyses: true,
    viewResults: true,
    downloadResultFiles: true,
    manageAdmin: true,
    inviteUsers: true,
    viewUsers: true,
  },

  bioinformatics: {
    createBuild: true,
    viewBuilds: true,
    modifyBuilds: true,
    executeBuilds: true,
    viewData: true,
    uploadData: true,
    deleteData: true,
    downloadData: true,
    viewAnalyses: true,
    viewResults: true,
    downloadResultFiles: true,
    manageAdmin: false,
    inviteUsers: false,
    viewUsers: false
  },

  client: {
    createBuild: false,
    viewBuilds: true,
    modifyBuilds: false,
    executeBuilds: false,
    viewData: false,
    uploadData: false,
    deleteData: false,
    downloadData: false,
    viewAnalyses: false,
    viewResults: true,
    downloadResultFiles: true,
    manageAdmin: false,
    inviteUsers: false,
    viewUsers: false,
  },

  viewer: {
    createBuild: true,
    viewBuilds: true,
    modifyBuilds: false,
    executeBuilds: false,
    viewData: true,
    uploadData: true,
    deleteData: false,
    downloadData: true,
    viewAnalyses: true,
    viewResults: true,
    downloadResultFiles: true,
    manageAdmin: false,
    inviteUsers: false,
    viewUsers: false,
  }
};

// OR-based merge of permissions from all groups
export function getUserPermissions(groups = []) {
  const final = {};

  groups.forEach(group => {
    const perms = PERMISSIONS[group];
    if (!perms) return;

    Object.keys(perms).forEach(key => {
      final[key] = final[key] || perms[key];
    });
  });

  return final;
}
